const languages = [
  { value: "es-AR", text: "es-AR" },
  { value: "en-US", text: "en-US" },
  { value: "pt-BR", text: "pt-BR" }
];

export default languages;
